exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".popover-button-container{height:100%;display:flex;justify-content:center;align-items:center}.popover-button-container .popover-trigger{display:flex;flex-direction:column;align-items:center;justify-content:center;position:relative;background-color:transparent;box-shadow:none;padding:1rem !important;border:none;font-size:0.75rem;max-height:100%;max-width:100%;min-width:0;padding:1rem}@media (hover: hover) and (pointer: fine){.popover-button-container .popover-trigger:hover::after{background-color:rgba(0,0,0,0.07)}}.popover-button-container .popover-trigger::after{content:'';display:block;width:4rem;height:4rem;background-color:transparent;border-radius:50%;position:absolute;transition:background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms}.popover-button-container .popover-trigger .hamburger__icon{font-size:3em;height:0.75em;width:1em}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/dist/cjs.js?{"ident":"postcss"}!./src/components/PopoverButton/style.scss
// module id = 1510
// module chunks = 0